import moment from 'moment';
import {
  SET_CHANGED_PERMIT_FILTER,
  SET_FLAT_ID_PERMIT_FILTER,
  SET_HOUSE_ID_PERMIT_FILTER,
  SET_STREET_ID_PERMIT_FILTER,
  SET_STATUS_ID_PERMIT_FILTER,
  SET_TYPE_ID_PERMIT_FILTER,
  SET_DATE_RANGE_FIELD_PERMIT_FILTER,
  SET_DATE_RANGE_PERMIT_FILTER,
  SET_CHANGE_VISIBLE_PERMIT_FILTER,
  RESET_PERMIT_FILTER,
  SET_SEARCH_VALUE,
} from './types';
import { modes } from '../components/Search/constants';
import { permitKeys } from '../lib/permitKeys';

const defaultDateRange = [
  moment().subtract(3, 'month').add(1, 'days'),
  moment(),
];
const defaultPermitStatusIds = [
  permitKeys.UNDER_APPROVAL_PERMIT,
  permitKeys.ALLOWED_PERMIT,
];

const defaultFiltersState = {
  permitTypeId: undefined,
  permitStatusIds: defaultPermitStatusIds,
  houseId: undefined,
  addressId: undefined,
  streetId: undefined,
  clientId: undefined,
  dateRange: defaultDateRange,
  dateRangeField: 1, // Дата создания
};

const initState = {
  visiblePermitFilter: false,
  filterChanged: false,
  searchValue: {
    [modes.permits]: '',
    [modes.transports]: '',
  },
  ...defaultFiltersState,
};

const permitsFilterReducer = (state = initState, { type, payload }) => {
  switch (type) {
    case SET_CHANGED_PERMIT_FILTER:
      return {
        ...state,
        filterChanged: payload,
      };
    case SET_SEARCH_VALUE:
      return {
        ...state,
        searchValue: { ...state.searchValue, ...payload },
      };
    case RESET_PERMIT_FILTER:
      return {
        ...initState,
      };
    case SET_CHANGE_VISIBLE_PERMIT_FILTER:
      return {
        ...state,
        visiblePermitFilter: payload,
      };
    case SET_FLAT_ID_PERMIT_FILTER:
      return {
        ...state,
        addressId: payload,
      };
    case SET_HOUSE_ID_PERMIT_FILTER:
      return {
        ...state,
        houseId: payload,
      };
    case SET_STREET_ID_PERMIT_FILTER:
      return {
        ...state,
        streetId: payload,
      };
    case SET_STATUS_ID_PERMIT_FILTER:
      return {
        ...state,
        permitStatusIds: payload,
      };
    case SET_TYPE_ID_PERMIT_FILTER:
      return {
        ...state,
        permitTypeId: payload,
      };
    case SET_DATE_RANGE_FIELD_PERMIT_FILTER:
      return {
        ...state,
        dateRangeField: payload,
      };
    case SET_DATE_RANGE_PERMIT_FILTER:
      return {
        ...state,
        dateRange: payload,
      };
    default:
      return state;
  }
};

export default permitsFilterReducer; //permitsFilterStore
